/* eslint-disable import/prefer-default-export */
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const apiGetDashboardData = () => {
  return Request.call({
    url: `/micro/dashboard`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiUpdateUserLandingTour = (data) => {
  return Request.call({
    url: `/micro/users/landing-tour`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};